import { Footer } from '@/previewThemes/classic/Footer';
import { Header } from '@/previewThemes/classic/Header';
import { Product } from '@/previewThemes/classic/Product';
import type { ThemePackage } from '@/previewThemes/types';

/**
 * The base theme, and the one every other theme falls back to.
 *
 * It declares no specs on purpose: the base values in `types.ts` *are* this
 * theme's values, and a second copy of them here would be the copy that goes
 * stale. It does supply every component slot, because a theme that overrides
 * no header still has to render one.
 */
export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  // What this theme used to write on `BuyBox` and `ProductGallery` by hand.
  // The merchant's components read it wherever they have left a setting at
  // "the theme's own", which is where every shop starts - so a shop nobody
  // has arranged renders the product page this theme has always drawn.
  parts: {
    product_details: {
      presentation: {
        classes: { product_title: 'text-3xl' },
      },
    },
  },
};
